<template>
    <ion-list>
        <ion-item v-for="checkbox in checkboxes" :key="checkbox.label">
            <base-checkbox
                :value="checkbox.value"
                id="schaden-gebaeude"
                @input="changeCheckboxValues($event, checkbox.label)"
            ></base-checkbox>
            <ion-label>{{ checkbox.label }}</ion-label>
        </ion-item>
    </ion-list>
</template>

<script>
import BaseCheckbox from "@/components/BaseCheckbox";

export default {
    components: { BaseCheckbox },
    props: {
        checkboxes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            checkboxValues: [],
        };
    },
    methods: {
        changeCheckboxValues(event, checkboxLabel) {
            if (event) {
                if (!this.checkboxValues.includes(checkboxLabel)) {
                    this.checkboxValues.push(checkboxLabel);
                }
            } else {
                if (this.checkboxValues.includes(checkboxLabel)) {
                    this.checkboxValues.splice(
                        this.checkboxValues.indexOf(checkboxLabel),
                        1
                    );
                }
            }
        },
    },
    mounted() {},
    watch: {
        checkboxValues(val) {
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
